export default __webpack_public_path__ + "static/media/component-2.59c0e7ff.png";